// extracted by mini-css-extract-plugin
export default {"projects-wrapper":"workproject_projects-wrapper__oZFSf","project-content":"workproject_project-content__KJkel"};